module.exports = {
    亚马逊: 'Amazon',
    沃尔玛: 'Walmart',
    星巴克: 'Starbucks',
    苹果卡: 'Apple',
    PayPal: 'Paypal',
    success: 'успешно',
    selected: 'Выбрано',
    chooseGiftFirst: 'Сначала выберите подарочную карту Apple или Starbucks.',
    综合评价: "Общая оценка",
    inputNotSame: "Введенные данные не совпадают",
    example: 'Пример',
    "btnPrev": "Назад",
    // 选择语言
    popupTitle: 'Выберите язык',
    // 发送
    send: 'Подтвердить',
    // 中文
    chinese: '中文',
    // 法语
    french: 'Français',
    // 英语
    english: 'English',
    // 德语
    german: 'Deutsch',
    // 西班牙语
    spanish: 'Español',
    // 意大利语
    italian: 'Italiano',
    // 发送邮件
    sendEmail: 'Отправить письмо',
    // 改变语言
    changeLanSes: 'Язык успешно изменен',
    // 系统标题
    title: 'Golos Pokupatelya',
    // 系统解释
    details: 'Прислушиваемся к мнению покупателей и предлагаем качественные товары и услуги.\nСпасибо, что вы с нами!',
    fileSizeOver: "Файл слишком велик, поддерживаются изображения до 10 МБ.",
    lowTextarea: 'Ваши отзывы помогут нам постоянно совершенствовать наши продукты и услуги.',
    placeholderOrderNo: "Пожалуйста, введите номер заказа (формат: 000-0000000-0000000)",
    "picUploadSuccessText": "Изображение успешно загружено",
    "picUploadErrorText": "Ошибка при загрузке изображения",
    "orderNotExistText": "Заказ не существует",
    "orderInvalidText": "Этот заказ недействителен",
    "networkErrorText": "Ошибка сети",
    "orderErrorText": "Ошибка заказа",
    // step1
    formBasic: {
        confirm_btn: "ОК",
        "order_help_title": "Помощь с номером заказа",
    "order_help_content": "Если вы не знаете номер своего заказа, пожалуйста, свяжитесь с нами, чтобы узнать, как его получить. Наш e-mail: ",
        form_code: 'Код подтверждения',
        form_code_placeholder: 'Пожалуйста, введите код подтверждения',
        "get_code": "Получить код",
        "code_sent_success": "Код успешно отправлен",
        title: 'Зарегистрируйте гарантию и<br><span style="color:#C9A127">получите таинственный подарок</span>',
        form_name: 'Имя',
        platform_name: 'Платформа',
        platform_name_placeholder: 'Пожалуйста, выберите платформу',
        form_email: 'Электронная почта',
        form_email_note: 'для доставки подарка и поддержки',
        form_order: 'Номер заказа',
        form_order_error_placeholder: 'Пожалуйста, введите номер заказа (формат: 000-0000000-0000000)',
        order_why: '*Как найти номер заказа?',
        order_answer: '*Мы не передаем ваши личные данные третьим лицам. Ваша информация в безопасности и используется исключительно для активации гарантии.',
        btn_text: 'Активировать сейчас',
        "form_name_placeholder": "Пожалуйста, введите ваше имя",
        "form_platform_placeholder": "Пожалуйста, выберите платформу",
        "form_email_placeholder": "Пожалуйста, введите вашу электронную почту",
        "form_email_error_placeholder": "Пожалуйста, введите корректный адрес почты",
        "form_order_placeholder": "Пожалуйста, введите номер вашего заказа"
    },
    // step2
    showGiftCard: {
        title: 'Ваша расширенная гарантия активирована.<br>Мы добавили <strong>9 месяцев</strong> гарантийного обслуживания для вашего товара.<br>Спасибо за покупку!',
        text: '🎁 Получите подарочную карту на 20 $ и поделитесь впечатлениями<br><small>(Это займет меньше 1 минуты)</small>',
        gift_card_text: 'Выберите электронную подарочную карту на 20 $',
        btn_text: 'Получить награду'
    },
    // step3
    expectations: {
        title: `Благодарим вас за выбор наших товаров и услуг!`,
        text: ' Если товар соответствует вашим ожиданиям или принес небольшой сюрприз, почему бы не оставить положительный отзыв на сайте, где вы его купили? Оставьте отзыв и получите подарочную карту на $10!!',
        btn_text: 'Следующий шаг'
    },
    // step3
    star: {
        title: 'Довольны ли вы продуктом или нашим сервисом?',
        text: ' Пожалуйста, поставьте оценку товару ниже:',
        star__placeholder: 'Пожалуйста, ответьте на все вопросы перед отправкой!',
        written: 'Напишите отзыв: <span style="color:#F40000">(Опционально)</span>',
        written_placeholder: 'Что вам понравилось? Для чего вы использовали этот продукт?',
        btn_text: 'Следующий шаг'
    },
    // step4
    ensureEmail: {
        title: `Поздравляем!</br>
Вы завершили опрос.
`,
        text: `Пожалуйста, подтвердите адрес электронной почты, вы получите подарочный код на этот адрес:</br>
 <span style="color:#F40000">customerservice8@yeah.net</span>`,
        email_placeholder: 'Пожалуйста, подтвердите адрес электронной почты!',
        btn_text: 'Следующий шаг'
    },
    // step5
    reviewGuide: {
        title: 'Как оставить отзыв на платформе, где вы совершили покупку',
        subtitle: 'Выберите платформу, чтобы увидеть инструкции.'
    },
    channelSelect: {
        title: `Ваше мнение важно! `,
        text: `Благодарим вас за ценный отзыв! Теперь вы можете выбрать подарок по своему вкусу!!!`,
        footer: '*О подарке:</br> Без платы за доставку, без скрытых комиссий, кредитная карта не требуется',
        btn_text: 'Я хочу это'
    },
    // step6
    uploadPic: {
        guideText: 'Нужна помощь со скриншотом?<br><small>Выберите ниже платформу покупки, чтобы быстро ознакомиться с инструкцией.</small>',
       "title": "Пожалуйста, загрузите скриншот вашего опыта использования продукта.",
  "text": "Чтобы получить подарочную карту на 20 $, просто отправьте ниже скриншот<br>опубликованного вами отзыва.",
        add_pic: 'Нажмите, чтобы загрузить, или перетащите файл',
        add_pic_text: 'JPG / PNG, до 10 МБ',
        btn_text: 'Отправить и получить подарок',
        uploading: 'Загрузка... Пожалуйста, подождите',
        upload_required: 'Перед продолжением загрузите скриншот.',
        "no_file_selected": "Файл не выбран"
    },
    // step7
    cityForm: {
        title: '*Аксессуары</br>Адрес доставки: ',
        text: '(Пожалуйста, подтвердите адрес доставки, бесплатный подарок будет отправлен в течение 3-5 рабочих дней.)',
        form_city: 'Город',
        form_state: 'Штат/Регион',
        form_postal_code: 'Почтовый индекс',
        form_country: 'Страна',
        btn_text: 'Подтвердить',
        "form_city_placeholder": "Пожалуйста, введите ваш город",
        "form_state_placeholder": "Пожалуйста, введите ваш регион",
        "form_postal_code_placeholder": "Пожалуйста, введите почтовый индекс",
        "form_country_placeholder": "Пожалуйста, введите вашу страну"
    },
    // step7
    paypalForm: {
        title: 'Куда отправить подарочную карту на 20 $?',
        text: '(Пожалуйста, проверьте правильность данных PayPal, чтобы избежать задержек.)',
        form_paypal: 'Аккаунт PayPal',
        form_ensure_paypal: 'Подтвердите аккаунт PayPal',
        form_paypal_name: 'Имя владельца аккаунта PayPal',
        btn_text: 'Подтвердить',
        "form_paypal_placeholder": "Пожалуйста, введите ваш аккаунт PayPal",
        "form_ensure_paypal_placeholder": "Пожалуйста, подтвердите ваш аккаунт PayPal",
        "form_paypal_name_placeholder": "Пожалуйста, введите ваше имя в PayPal"
    },
    // thanks-all
    thanksAll: {
        doneTitle: 'Готово! 🎉', doneDescription: 'Ваш скриншот получен! Запрос на подарочную карту обрабатывается.',
        request: 'Запрос на подарочную карту', processing: 'Обработка', deliveryPrefix: 'Ожидаемая доставка:', deliveryTime: '1-2 рабочих дня', deliverySuffix: 'по электронной почте.',
        rewardTitle: 'Ваша награда', rewardDescription: 'Электронная подарочная карта на 20 $ будет отправлена на вашу почту.',
        verifyStep: 'Мы проверим ваш скриншот в течение 1-2 рабочих дней.', approvedStep: 'После одобрения подарочная карта будет отправлена вам по электронной почте.', spamStep: 'Не забудьте проверить папку со спамом/нежелательной почтой.', supportText: 'Есть вопросы? Свяжитесь со службой поддержки по адресу',
        title: 'Благодарим за ваш вклад!',
        text: `Ваше ценное мнение поможет нам улучшить качество продукции. 
Если у вас возникнут вопросы в процессе использования, пожалуйста, свяжитесь с нами.`
    },
    // thanks
    thanks: {
        title: 'Поздравляем!',
        title_desc1: `Ваша гарантия активирована!
Большое спасибо за ваше время.`,
        title_default_paypal_desc1: `Ваша гарантия активирована!
Большое спасибо за ваше время. Ваша награда будет выдана в течение 24–72 часов.`,
    },
    // flow
    flow: {
        step1: 'Перейдите на главную страницу и выберите "Мои заказы"',
        step2: 'Найдите заказ в нашем магазине и нажмите на него',
        step3: 'Найдите страницу "Информация о заказе" и нажмите "Посмотреть детали заказа"',
        step4: 'Order # — это номер вашего заказа, вы можете скопировать его и заполнить на нашем сайте',
    }
}
